<script>
import CalendarIcon from '~/components/public/CalendarIcon.vue';
import Button from "~/components/ui/Button.vue";
export default {
  name: 'MeetingItemResult',
  components: {Button},
  setup() {
    const route = useRoute();
    return { route };
  },
  props: {
    meeting: {
      type: Object,
      required: true
    }
  },
  data() {
    let search_result_type = 'Meeting';
    let search_result_text = '';
    if (this.meeting.search_highlight?.agenda) {
      search_result_type = 'Agenda';
      search_result_text = '...' + this.meeting.search_highlight.agenda + '...';
    } else if (this.meeting.search_highlight?.minutes) {
      search_result_type = 'Minutes';
      search_result_text = '...' + this.meeting.search_highlight.minutes + '...';
    } else if (this.meeting.search_highlight?.attachment) {
      search_result_type = 'Meeting';
      search_result_text = '';
    }
    return {
      search_result_type,
      search_result_text,
    };
  },
  computed: {
    meetingLink() {
      const base = `/${this.route.params.site_slug}/meetings/${this.meeting.slug}`;
      if (this.search_result_type === 'Agenda') {
        return base + '/agenda';
      }
      return base;
    }
  }
}
</script>

<template>
  <div class="meeting_item">
    <NuxtLink :to="meetingLink">
      <div class="flex-1 flex-col justify-start items-start gap-1">
        <div class="inline-flex justify-start items-baseline gap-2">
          <font-awesome :icon="['far', 'calendar']" size="xs" class="meeting-result-icon" />
          <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ meeting.title }}</div>
          <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
          <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ search_result_type }}</div>
        </div>
        <div v-if="search_result_text" class="self-stretch justify-center highlight"><span v-html="search_result_text"></span></div>
      </div>
    </NuxtLink>

    <div v-if="meeting.attachment_matches && meeting.attachment_matches.length" class="mt-2">
      <a
        v-for="match in meeting.attachment_matches"
        :key="match.id"
        :href="match.url"
        target="_blank"
        class="block pl-6 mt-2"
      >
        <div class="flex-1 flex-col justify-start items-start gap-1">
          <div class="inline-flex justify-start items-baseline gap-2 flex-wrap">
            <font-awesome :icon="['far', 'file-pdf']" size="xs" class="document-result-icon" />
            <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ meeting.title }}</div>
            <template v-if="match.agenda_item">
              <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
              <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">Agenda</div>
              <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
              <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ match.agenda_item }}</div>
            </template>
            <font-awesome :icon="['fas', 'angle-right']" size="xs"/>
            <div class="justify-center text-sky-950 text-sm font-medium font-['Söhne'] leading-tight">{{ match.title }}</div>
          </div>
          <div v-if="match.context" class="self-stretch justify-center highlight"><span v-html="match.context"></span></div>
        </div>
      </a>
    </div>
  </div>
</template>

<style>
  .meeting_item {
    margin-bottom: 32px;
  }
  .highlight {
    color: #64748b; /* text-slate-500 */
    font-size: 0.875rem; /* text-sm (14px) */
    font-weight: 400; /* font-normal */
    font-family: 'Söhne', sans-serif; /* font-['Söhne'] */
    line-height: 1.25; /* leading-tight */
    background-color: unset;
  }

  mark {
    background-color: unset;
    font-weight: 500;
  }

  .meeting-result-icon {
    color: #E23B3B;
  }

  .document-result-icon {
    color: #6366F1;
  }
</style>
